import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import BlurrImage from 'rebook/apps/utils/components/BlurrImage';
import cropStorageImage from 'rebook/apps/utils/urls/cropStorageImage';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';


const hidePreloader = (src) => {
  document.getElementsByClassName(src)[0].remove();
};

const StorageImage = ({
  width, height, src, alt, type, isBlurrable, disableLazyLoad, showPreloader, onClick, noWidth, ...otherProps }) => {
  if (!src) {
    return null;
  }

  const url = cropStorageImage(src, width, height, { type });
  const url2x = `${cropStorageImage(src, width, height, { size: 2, type })} 2x`;

  const params = {
    width,
    height,
    src: url,
    alt,
    ...otherProps,
  };

  if (noWidth) {
    delete params.width;
  }

  const image = showPreloader
    ? (
      <React.Fragment>
        <SpinnerLoader extraClassName={src} theme="light" />
        <img
          {...params} srcSet={url2x}
          onLoad={() => hidePreloader(src)}
          onClick={onClick ? () => onClick() : null} />
      </React.Fragment>
    )
    : (
      <img {...params} srcSet={url2x} onClick={onClick ? () => onClick() : null} />
    );

  const imageElement = disableLazyLoad
    ? image
    : (
      <LazyLoad offset={200} height={height}>
        {image}
      </LazyLoad>
    );

  // isBlurrable - the flag that decides to process the lq image or not
  return isBlurrable
    ? <BlurrImage {...params} srcSet={url2x} />
    : imageElement;
};

StorageImage.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  src: PropTypes.string,
  alt: PropTypes.string,
  isBlurrable: PropTypes.bool,
};

StorageImage.defaultProps = {
  alt: '',
  isBlurrable: false,
};

export default StorageImage;
